module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl3-75.45224fca.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl3-75.png
// module id = 3551
// module chunks = 11